import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementClosingDate } from '../models/engagement-closing-date.model';

export const FetchEngagementClosingDate = createAsyncThunk(
    'closingDate/fetch',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.get(
            `/api/Marketplace/Engagements/${engagementId}/ClosingDate`
        );

        if (response.status !== 200) {
            createNotification(
                'An error occurred while fetching the engagement closing date.',
                'error'
            );
            throw new Error('Failed to fetch engagement closing date');
        }

        return response.data as EngagementClosingDate;
    }
);
